
export default {
    name: 'ModalOrderShipmentDetails',

    props: {
        payload: {
            type: Object,
            default: () => {},
        },
        loadMoreProducts: {
            type: Function,
            default: () => {},
        },
        orderIndex: {
            type: Number,
            default: 0,
        },
        fetchMoreShipmentProducts: {
            type: Function,
            default: () => {},
        },
        shipmentIndex: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            shipmentProducts: [],
            hasNextPage: false,
            endCursor: null,
        }
    },

    computed: {
        isHidden() {
            return (
                !this.shipmentProducts ||
                this.shipmentProducts[this.shipmentIndex]?.length === 0
            )
        },
        trackingNumber() {
            return this.payload.shipments.edges[this.shipmentIndex].node
                .trackingNumber
        },
        trackingUrl() {
            return this.payload.shipments.edges[this.shipmentIndex].node
                .trackingUrl
        },
    },

    mounted() {
        this.shipmentProducts = this.payload.shipments.edges[
            this.shipmentIndex
        ].node.shipmentProducts.edges.map((item) => item.node)
        this.hasNextPage =
            this.payload.shipments.edges[
                this.shipmentIndex
            ].node.shipmentProducts.pageInfo.hasNextPage
        this.endCursor =
            this.payload.shipments.edges[
                this.shipmentIndex
            ].node.shipmentProducts.pageInfo.endCursor
    },

    methods: {
        async loadMoreHandler() {
            const tempShipmentProductDetails = (
                await this.loadMoreProducts(
                    this.hasNextPage,
                    this.endCursor,
                    'shipment'
                )
            )?.data?.order?.supplierOrders?.edges?.[this.orderIndex]?.node
                ?.shipments?.edges?.[this.shipmentIndex].node.shipmentProducts
            const newShipmentProducts = tempShipmentProductDetails?.edges.map(
                (item) => item.node
            )
            this.hasNextPage = tempShipmentProductDetails?.pageInfo?.hasNextPage
            this.endCursor = tempShipmentProductDetails?.pageInfo?.endCursor
            this.shipmentProducts = [
                ...this.shipmentProducts,
                ...newShipmentProducts,
            ]
        },
        getFirstImage(payload) {
            if (payload?.thumbnail) {
                return payload?.thumbnail
            } else {
                return require(`~assets/images/placeholders/unavailable-product.avif`)
            }
        },
    },
}
